import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const PercentageIndicator = ({ value, color }) => {
  const isPositive = value >= 0;

  const arrowStyles = {
    fontSize: 20,
    color: "#fff",
    position: "absolute",
    top: "-2px",
    left: "50%",
    transform: "translateX(-50%)",
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        border: `1px solid ${color}`,
        color: color,
        borderRadius: "16px",
        padding: "2px 6px",
        height: "24px",
        minWidth: "fit-content",
      }}
    >
      <Box
        sx={{
          width: "16px",
          height: "16px",
          borderRadius: "50%",
          backgroundColor: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        {isPositive ? (
          <ArrowDropUpIcon sx={arrowStyles} />
        ) : (
          <ArrowDropDownIcon sx={arrowStyles} />
        )}
      </Box>
      <Box component="span" sx={{ fontSize: 14, fontWeight: 500 }}>
        {Math.abs(value)}%
      </Box>
    </Box>
  );
};

PercentageIndicator.propTypes = {
  value: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};

export default PercentageIndicator;
